export const PROJECT_CYCLE_SEARCH = 'DELIVERY_CYCLE_ACTIVITY_SEARCH';

export const CYCLE_FREQUENCY = {
  WEEKLY: 'WEEKLY',
  BIWEEKLY: 'BIWEEKLY',
};

export const KEEP_CYCLE_DAYS = 'KEEP';
export const RESUBMIT_CYCLE_DAYS = 'RESUBMIT';

export const CYCLE_FREQUENCY_LABELS = {
  [CYCLE_FREQUENCY.WEEKLY]: 'Weekly',
  [CYCLE_FREQUENCY.BIWEEKLY]: 'Biweekly',
};

export const CYCLE_DAYS = {
  MONDAY: 'MONDAY',
  TUESDAY: 'TUESDAY',
  WEDNESDAY: 'WEDNESDAY',
  THURSDAY: 'THURSDAY',
  FRIDAY: 'FRIDAY',
};

export const CYCLE_DAYS_LABELS = {
  [CYCLE_DAYS.MONDAY]: 'Monday',
  [CYCLE_DAYS.TUESDAY]: 'Tuesday',
  [CYCLE_DAYS.WEDNESDAY]: 'Wednesday',
  [CYCLE_DAYS.THURSDAY]: 'Thursday',
  [CYCLE_DAYS.FRIDAY]: 'Friday',
};

export const CYCLE_SETTINGS_STATUS = {
  IN_APPROVAL: 'IN_APPROVAL',
  APPROVED: 'APPROVED',
  REJECTED: 'REJECTED',
};

export const CYCLE_ACTIVITY_STATUS = {
  NOT_STARTED: 'NOT_STARTED',
  IN_PROGRESS: 'IN_PROGRESS',
  COMPLETED: 'COMPLETED',
  SKIPPED: 'SKIPPED',
  EXPIRED: 'EXPIRED',
};

export const CYCLE_ACTIVITY_STATUS_LABELS = {
  [CYCLE_ACTIVITY_STATUS.NOT_STARTED]: 'Not started',
  [CYCLE_ACTIVITY_STATUS.IN_PROGRESS]: 'In progress',
  [CYCLE_ACTIVITY_STATUS.COMPLETED]: 'Completed',
  [CYCLE_ACTIVITY_STATUS.SKIPPED]: 'Skipped',
  [CYCLE_ACTIVITY_STATUS.EXPIRED]: 'Expired',
};
